<div class="pointer ex" [ngClass]="{'ex--modern': viewType === 'modern', 'ex--grid': viewType === 'grid', 'ex--product': item.type === 'PRODUCT'}" *ngIf="viewType !== 'list' && item">

  <div class="ex__img-container" [ngStyle]="{'align-self': viewType !== 'modern' ? '' : 'center'}" (click)="goDetails()">
    <img class="ex-img" [src]="setImage(item.mainImage,item.type)">
  </div>

  <div class="ex__data-container">
     <div class="ex__data" (click)="goDetails()">
         <a class="ex__data-title long-text-two-line" *ngIf="item.type === 'EXHIBITOR'" [title]="item.exhibitorName" [innerHTML]="item.exhibitorName" ></a>
         <a class="ex__data-title long-text-two-line" *ngIf="item.type === 'PRODUCT'" [title]="utilsService._api(item['productTranslation'], 'name')">{{utilsService._api(item['productTranslation'], 'name')}}</a>
     </div>

    <div class="ex__stand" *ngIf="item.type === 'EXHIBITOR'" (click)="goDetails()">
      <div *ngIf="isSponsored(item)" class="partner partner--gold" [style.color]="getProperty('colors.sponsoredTextColor')" [style.backgroundColor]="getProperty('colors.sponsoredColor')">
          <app-featured-icon [type]="'sponsored'" [color]="getProperty('colors.sponsoredTextColor')"></app-featured-icon>
          <span *ngIf="activeCustomTranslate">{{ 'sponsored' | customTranslation:'EXHIBITOR.SPONSORED':this.translateService.currentLang | translate }}</span>
          <span *ngIf="!activeCustomTranslate">{{ 'EXHIBITOR.SPONSORED' | translate }}</span>

      </div>
      <div *ngIf="isFeatured(item)" class="partner partner--silver" [style.color]="getProperty('colors.featuredTextColor')" [style.backgroundColor]="getProperty('colors.featuredColor')">
          <app-featured-icon [color]="getProperty('colors.featuredTextColor')"></app-featured-icon>
          <span *ngIf="activeCustomTranslate">{{ 'featured' | customTranslation:'EXHIBITOR.FEATURED':this.translateService.currentLang | translate }}</span>
          <span *ngIf="!activeCustomTranslate">{{ 'EXHIBITOR.FEATURED' | translate }}</span>
      </div>

      <div *ngIf="(!utilsService.isEmpty(this.subCatalogues) && this.subCatalogues)" class="subCatalogue"
        [style.color]="getColorSuCataloge(item, 'fgColor', subFgColor)"
        [style.backgroundColor]="getColorSuCataloge(item, 'bgColor', subBgColor)">
        <ng-container *ngIf="eventLabel[item.eventSapCode]; else elseBlock">{{ eventLabel[item.eventSapCode] }}</ng-container>
        <ng-template #elseBlock>{{ subCatalogues[0]['label'] }}</ng-template>
      </div>
      
      <div *ngIf="!!item.subEventLabel && item.subEventLabel.length > 0" class="subCatalogue" [style.color]="item.subFgColor"
        [style.backgroundColor]="item.subBgColor">{{ item.subEventLabel }}
      </div>

      <ng-container *ngIf="brands">
        <ng-container *ngIf="viewType === 'grid'">
          <div class="subcategory-container">
            <div class="subcategory subcategory--{{ i }}" *ngFor="let category of listNameCategories; let i = index">
              <span *ngIf="i < 1  && !isSector(item) ">{{utilsService._api(category.translations, 'name')}}</span>
            </div>
    
            <div class="subcategory subcategory--0" *ngIf="isSector(item)">
              <span>{{utilsService._api(sectorMap[item.sectorId], 'name')}}  </span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="viewType === 'modern'">
          <div class="subcategory-container subcategory subcategory--0">
            <ng-container *ngFor="let category of listNameCategories; let i = index">
              <ng-container *ngIf="i < listNameCategories.length - 1 && !isSector(item)">{{utilsService._api(category.translations, 'name')}}, </ng-container>
              <ng-container *ngIf="i === listNameCategories.length - 1 && !isSector(item)">{{utilsService._api(category.translations, 'name')}}</ng-container>
            </ng-container>
          </div>
          <div class="subcategory-container subcategory subcategory--0" *ngIf="isSector(item)">
            <ng-container> {{utilsService._api(sectorMap[item.sectorId], 'name')}} </ng-container>
          </div>
        </ng-container>
      </ng-container>

      <span *ngIf="item.standLocation && item.type === 'EXHIBITOR'">
        <app-stand-display [standData]="item.standLocation"></app-stand-display>
      </span>

      <span *ngIf="item.type === 'PRODUCT' && viewType === 'modern'" class="product__exhibitor-name">
        {{cropText(item.exhibitorName, 17)}}
      </span>

    </div>
    
    <div class="ex__stand" *ngIf="item.type === 'PRODUCT'" (click)="goDetails()">
      <div *ngIf="isSponsored(item)" class="partner partner--gold" [style.color]="getProperty('colors.productSponsoredTextColor')" [style.backgroundColor]="getProperty('colors.productSponsoredColor')">
          <app-featured-icon [type]="'sponsored'" [color]="getProperty('colors.productSponsoredTextColor')"></app-featured-icon>
          <span *ngIf="activeCustomTranslate">{{ 'product.sponsored' | customTranslation:'PRODUCT.SPONSORED':this.translateService.currentLang | translate }}</span>
          <span *ngIf="!activeCustomTranslate">{{ 'PRODUCT.SPONSORED' | translate }}</span>
      </div>
      <div *ngIf="isFeatured(item)" class="partner partner--silver" [style.color]="getProperty('colors.productFeaturedTextColor')" [style.backgroundColor]="getProperty('colors.productFeaturedColor')">
          <app-featured-icon [color]="getProperty('colors.productFeaturedTextColor')"></app-featured-icon>
          <span *ngIf="activeCustomTranslate">{{ 'product.featured' | customTranslation:'PRODUCT.FEATURED':this.translateService.currentLang | translate }}</span>
          <span *ngIf="!activeCustomTranslate">{{ 'PRODUCT.FEATURED' | translate }}</span>
      </div>
      <div class="subcategory-container">
        <div class="subcategory subcategory--{{ i }}" *ngFor="let category of listNameCategories; let i = index">
          {{utilsService._api(category.translations, 'name')}}
        </div>
      </div>
      <span class="product__exhibitor-name long-text-one-line">
        {{ cropText(item.exhibitorName, 27) }}
      </span>
    </div>

    <div class="ex__actions" [ngClass]="{'ex__actions--product--grid': item.type === 'PRODUCT' && viewType === 'grid', 'ex__actions--product--modern': item.type === 'PRODUCT' && viewType === 'modern'}">
      <img class="pointer fix-image" *ngIf="item.type === 'EXHIBITOR' && eventData['mapsActive'] && item.standLocation && getProperty('maps.firamaps.enabled')" src="assets/img/place.svg" (click)="goToMaps()">
      <img class="pointer action-note" [hidden]="item.note || !item.isFavorite" (click)="toggleShowNote(item, $event)" width="28" height="30" src="assets/img/note_add.svg">
      <img class="pointer action-note" [hidden]="!item.note || !item.isFavorite" (click)="toggleShowNote(item, $event)" width="28" height="30" src="assets/img/note_added.svg">
      <img class="pointer action-favorites" [hidden]="item.isFavorite" (click)="addToFavorites(item)" width="28" height="28" src="assets/img/favorite_border.svg">
      <img class="pointer action-favorites" [hidden]="!item.isFavorite" (click)="deleteFromFavorites(item)" src="assets/img/favorite_filled.svg">
    </div>
  </div>
     <app-card-note *ngIf="item.showNote" [item]="item" [selectedView]="viewType"></app-card-note>
 </div>

  <div class="ex ex--list pointer " *ngIf="viewType === 'list' && item" [ngClass]="{'ex--product': item.type === 'PRODUCT'}">
    
    <div class="ex__img-container" (click)="goDetails()">
      <img class="ex-img" [src]="setImage(item.mainImage,item.type)">
    </div>

    <div class="ex__data-container" (click)="goDetails()">
      <div class="ex__data">
          <a class="ex__data-title long-text-two-line" *ngIf="item.type === 'EXHIBITOR'" [title]="item.exhibitorName" [innerHTML]="item.exhibitorName" ></a>
          <a class="ex__data-title long-text-two-line" *ngIf="item.type === 'PRODUCT'" [title]="utilsService._api(item['productTranslation'], 'name')">{{utilsService._api(item['productTranslation'], 'name')}}</a>
      </div>
      
      <div class="ex__stand">
        <div *ngIf="(!utilsService.isEmpty(this.subCatalogues) && this.subCatalogues)" class="subCatalogue"
          [style.color]="getColorSuCataloge(item, 'fgColor', subFgColor)"
          [style.backgroundColor]="getColorSuCataloge(item, 'bgColor', subBgColor)">
          <ng-container *ngIf="eventLabel[item.eventSapCode]; else elseBlock">{{ eventLabel[item.eventSapCode] }}</ng-container>
          <ng-template #elseBlock>{{ subCatalogues[0]['label'] }}</ng-template>
        </div>
        
        <ng-container *ngIf="brands">
          <div class="subcategory-container">
            <div class="subcategory subcategory--{{ i }}" *ngFor="let category of listNameCategories; let i = index">
              <span *ngIf="i < 1 && !isSector(item)" >{{utilsService._api(category.translations, 'name')}}</span>
            </div>
            <div class="subcategory subcategory--01">
              <span *ngIf="isSector(item)">{{utilsService._api(sectorMap[item.sectorId], 'name')}}</span>
            </div>
          </div>
          <span *ngIf="item.type === 'PRODUCT'" class="product__exhibitor-name long-text-one-line" >
            {{ item.exhibitorName }}
          </span>
        </ng-container>
      </div>


      <span *ngIf="item.standLocation && item.type === 'EXHIBITOR'">
        <app-stand-display [standData]="item.standLocation"></app-stand-display>
      </span>

      <div *ngIf="!item.showNote && item.type === 'EXHIBITOR'" class="description long-text-two-line" >
        {{ utilsService._api(item.exhibitorDescription, 'description') }}
      </div>
      <div *ngIf="item.type === 'EXHIBITOR'" class="description long-text-two-line" >
        {{ utilsService._api(item.exhibitorTranslations, 'description') }}
      </div>
      <div *ngIf="item.type === 'PRODUCT'" class="description description--product long-text-three-line">
        {{ utilsService._api(item.productTranslation, 'description') }}
      </div>

    </div>
    
    <div class="ex__actions">
        <div *ngIf="isSponsored(item) && item.type === 'EXHIBITOR'" class="partner partner--gold" [style.color]="getProperty('colors.sponsoredTextColor')" [style.backgroundColor]="getProperty('colors.sponsoredColor')">
            <app-featured-icon [type]="'sponsored'" [color]="getProperty('colors.sponsoredTextColor')"></app-featured-icon>
            <span *ngIf="activeCustomTranslate">{{ 'sponsored' | customTranslation:'EXHIBITOR.SPONSORED':this.translateService.currentLang | translate }}</span>
            <span *ngIf="!activeCustomTranslate">{{ 'EXHIBITOR.SPONSORED' | translate }}</span>
        </div>

        <div *ngIf="isFeatured(item) && item.type === 'EXHIBITOR'" class="partner partner--silver" [style.color]="getProperty('colors.featuredTextColor')" [style.backgroundColor]="getProperty('colors.featuredColor')">
            <app-featured-icon [color]="getProperty('colors.featuredTextColor')"></app-featured-icon>
            <span *ngIf="activeCustomTranslate">{{ 'featured' | customTranslation:'EXHIBITOR.FEATURED':this.translateService.currentLang | translate }}</span>
            <span *ngIf="!activeCustomTranslate">{{ 'EXHIBITOR.FEATURED' | translate }}</span>
        </div>

        <div *ngIf="isSponsored(item) && item.type === 'PRODUCT'" class="partner partner--gold" [style.color]="getProperty('colors.productSponsoredTextColor')" [style.backgroundColor]="getProperty('colors.productSponsoredColor')">
            <app-featured-icon [type]="'sponsored'" [color]="getProperty('colors.productSponsoredTextColor')"></app-featured-icon>
            <span *ngIf="activeCustomTranslate">{{ 'product.sponsored' | customTranslation:'PRODUCT.SPONSORED':this.translateService.currentLang | translate }}</span>
            <span *ngIf="!activeCustomTranslate">{{ 'PRODUCT.SPONSORED' | translate }}</span>
        </div>

        <div *ngIf="isFeatured(item) && item.type === 'PRODUCT'" class="partner partner--silver" [style.color]="getProperty('colors.productFeaturedTextColor')" [style.backgroundColor]="getProperty('colors.productFeaturedColor')">
            <app-featured-icon [color]="getProperty('colors.productFeaturedTextColor')"></app-featured-icon>
            <span *ngIf="activeCustomTranslate">{{ 'product.featured' | customTranslation:'PRODUCT.FEATURED':this.translateService.currentLang | translate }}</span>
            <span *ngIf="!activeCustomTranslate">{{ 'PRODUCT.FEATURED' | translate }}</span>
        </div>


        <div class="action-container pointer" [hidden]="item.isFavorite" (click)="addToFavorites(item)">
          <img class="pointer action-favorites" width="28" height="28" src="assets/img/favorite_border.svg">
          <span>{{ 'EXHIBITOR.ADD_TO_FAVORITES' | translate }}</span>
        </div>
        <div class="action-container pointer" [hidden]="!item.isFavorite" (click)="deleteFromFavorites(item)">
          <img class="pointer action-favorites" width="28" height="28" src="assets/img/favorite_filled.svg">
          <span>{{ 'EXHIBITOR.ADD_TO_FAVORITES' | translate }}</span>
        </div>
        <div class="action-container pointer" [hidden]="!item.isFavorite" (click)="toggleShowNote(item, $event)">
          <img class="pointer action-note" [hidden]="item.note" width="28" height="30"  src="assets/img/note_add.svg">
          <img class="pointer action-note" [hidden]="!item.note" width="28" height="30"  src="assets/img/note_added.svg">
          <span [hidden]="item.note">{{ 'EXHIBITOR.ADD_NOTE' | translate }}</span>
          <span [hidden]="!item.note">{{ 'EXHIBITOR.SEE_NOTE' | translate }}</span>
        </div>

        <div class="action-container pointer" *ngIf="item.type === 'EXHIBITOR' && eventData['mapsActive'] && item.standLocation" (click)="goToMaps()">
          <img class="pointer action-map" width="28" height="28" src="assets/img/place.svg">
          <span>{{ 'EXHIBITOR.VIEW_MAP' | translate }}</span>
        </div>

    </div>
    <app-card-note *ngIf="item.showNote" [item]="item" [selectedView]="viewType"></app-card-note>
  </div>


